import { getAnalytics, isSupported, type Analytics } from "firebase/analytics";
import { app } from "./app";

export const getAnalyticsInstance = async (): Promise<Analytics | null> => {
  try {
    const supported = await isSupported();
    if (supported) {
      const analytics = getAnalytics(app);
      console.log("✅ Firebase Analytics initialisé");
      return analytics;
    }

    console.log("⚠️ Firebase Analytics non supporté sur ce navigateur");
    return null;
  } catch (error) {
    console.error("❌ Erreur lors de l'initialisation de Firebase Analytics:", error);
    return null;
  }
};
